import React from 'react';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import PreviousResponsesTab from './PreviousResponsesTab';
import SubmitLinkTab from './SubmitLinkTab';

const DemonstrationSubmissions = ({
  demonstration,
  path,
  user,
  previousAttempts,
  status,
}) => {
  return (
    <div className="d-f container m-a p-16">
      <TabbedView selectedIndex={status === 'incomplete' ? 0 : 1}>
        <TabList className="mb-32" tabClassName="c-brand-night">
          <Tab disabled={previousAttempts && status !== 'incomplete'}>
            {t('demonstrations.submit_link')}
          </Tab>
          <Tab disabled={previousAttempts.length === 0}>
            {t('demonstrations.previous_responses')}
          </Tab>
        </TabList>
        <TabPanel disabled={previousAttempts && status !== 'incomplete'}>
          <SubmitLinkTab
            user={user}
            path={path}
            demonstration={demonstration}
          />
        </TabPanel>
        <TabPanel disabled={previousAttempts.length === 0}>
          <PreviousResponsesTab
            demonstration={demonstration}
            path={path}
            previousAttempts={previousAttempts}
          />
        </TabPanel>
      </TabbedView>
    </div>
  );
};

export default DemonstrationSubmissions;
